import type { TaskListType } from "@orsane/schema/task-lists";

const queryKeys = {
    inbox: () => ["inbox"],
    attributes: (taskListId: number | undefined, type: TaskListType) => ["attributes", taskListId, type],
};

export default queryKeys;
